import { logoBase64 } from "@compass/core";
import { ReactNode, useState } from "react";

export const PdfReportCss = () => {
  return (
    <style>{`
        table {
            width: 100%;
            border: 1px solid gray;
            border-collapse: collapse;
            margin-bottom: 15px;
            table-layout: fixed;
        }

        thead th {
            text-align: left;
            padding-left: 4px;
            padding-right: 4px;
        }
    
        tbody td {
            padding-left: 4px;
                padding-right: 4px;
        }
    
        th, td {
            border: 1px solid gray;
            page-break-inside: avoid;
        }
    `}</style>
  );
};

export const getPdfReportSpacing = (spacing: "sm" | "md" | "lg" | undefined): string | undefined => {
  switch (spacing) {
    case "sm":
      return "10px";
    case "md":
      return "30px";
    case "lg":
      return "50px";
    default:
      return undefined;
  }
};

export const PdfReportHeader = (props: { title: string; tenantName?: string }) => {
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
      }}
    >
      <img style={{ position: "absolute", left: "0", top: "0" }} width={50} src={logoBase64} />
      <div style={{ paddingBottom: "30px", margin: "auto 0" }}>
        <div style={{ textAlign: "center", fontSize: "28px" }}>{props.title}</div>
        <div style={{ textAlign: "center", fontSize: "18px", textTransform: "uppercase" }}>{props.tenantName}</div>
      </div>
      <div></div>
    </div>
  );
};

export const PdfReportDataDisplay = (props: {
  label: string;
  value?: ReactNode | undefined;
  labelStyle?: React.CSSProperties | undefined;
  valueStyle?: React.CSSProperties | undefined;
}) => {
  return (
    <div style={{ display: "flex", flexDirection: "row", paddingTop: "2px", paddingBottom: "2px" }}>
      <div style={{ width: "200px", ...props.labelStyle }}>{props.label}:</div>
      <div style={{ flexGrow: 1, ...props.valueStyle }}>{props.value}</div>
    </div>
  );
};

export const PdfReportSignBox = (props: { label: string }) => {
  return (
    <div
      style={{
        display: "block",
        width: "300px",
        borderTop: "1px solid black",
        paddingTop: "5px",
        marginTop: "40px",
        fontWeight: "bold",
        marginLeft: "auto",
        marginRight: "0px",
      }}
    >
      {props.label}
    </div>
  );
};

// export const PdfReportFooter = () => {
//   return <div>Powered by Compass</div>;
//   return <div style={{ position: "absolute", left: "0", bottom: "-30px" }}>Powered by Compass</div>;
// };
